/**
 * The 58 Algerian wilayas (the 48 historic + the 10 promoted in 2019), as `{ value, label }` pairs
 * for the DemandeAccesPage <Select>. `value` is the official 1-based wilaya code (zero-padded), the
 * stable identifier the onboarding endpoint expects; `label` is the FR transliterated name. A single
 * authored list so the self-signup geographic scope matches the SIL's territorial config later.
 */
export interface WilayaOption {
  /** Official wilaya code, zero-padded (e.g. "16" Alger). */
  value: string;
  label: string;
}

export const WILAYAS: ReadonlyArray<WilayaOption> = [
  { value: "01", label: "01 — Adrar" },
  { value: "02", label: "02 — Chlef" },
  { value: "03", label: "03 — Laghouat" },
  { value: "04", label: "04 — Oum El Bouaghi" },
  { value: "05", label: "05 — Batna" },
  { value: "06", label: "06 — Béjaïa" },
  { value: "07", label: "07 — Biskra" },
  { value: "08", label: "08 — Béchar" },
  { value: "09", label: "09 — Blida" },
  { value: "10", label: "10 — Bouira" },
  { value: "11", label: "11 — Tamanrasset" },
  { value: "12", label: "12 — Tébessa" },
  { value: "13", label: "13 — Tlemcen" },
  { value: "14", label: "14 — Tiaret" },
  { value: "15", label: "15 — Tizi Ouzou" },
  { value: "16", label: "16 — Alger" },
  { value: "17", label: "17 — Djelfa" },
  { value: "18", label: "18 — Jijel" },
  { value: "19", label: "19 — Sétif" },
  { value: "20", label: "20 — Saïda" },
  { value: "21", label: "21 — Skikda" },
  { value: "22", label: "22 — Sidi Bel Abbès" },
  { value: "23", label: "23 — Annaba" },
  { value: "24", label: "24 — Guelma" },
  { value: "25", label: "25 — Constantine" },
  { value: "26", label: "26 — Médéa" },
  { value: "27", label: "27 — Mostaganem" },
  { value: "28", label: "28 — M'Sila" },
  { value: "29", label: "29 — Mascara" },
  { value: "30", label: "30 — Ouargla" },
  { value: "31", label: "31 — Oran" },
  { value: "32", label: "32 — El Bayadh" },
  { value: "33", label: "33 — Illizi" },
  { value: "34", label: "34 — Bordj Bou Arréridj" },
  { value: "35", label: "35 — Boumerdès" },
  { value: "36", label: "36 — El Tarf" },
  { value: "37", label: "37 — Tindouf" },
  { value: "38", label: "38 — Tissemsilt" },
  { value: "39", label: "39 — El Oued" },
  { value: "40", label: "40 — Khenchela" },
  { value: "41", label: "41 — Souk Ahras" },
  { value: "42", label: "42 — Tipaza" },
  { value: "43", label: "43 — Mila" },
  { value: "44", label: "44 — Aïn Defla" },
  { value: "45", label: "45 — Naâma" },
  { value: "46", label: "46 — Aïn Témouchent" },
  { value: "47", label: "47 — Ghardaïa" },
  { value: "48", label: "48 — Relizane" },
  { value: "49", label: "49 — Timimoun" },
  { value: "50", label: "50 — Bordj Badji Mokhtar" },
  { value: "51", label: "51 — Ouled Djellal" },
  { value: "52", label: "52 — Béni Abbès" },
  { value: "53", label: "53 — In Salah" },
  { value: "54", label: "54 — In Guezzam" },
  { value: "55", label: "55 — Touggourt" },
  { value: "56", label: "56 — Djanet" },
  { value: "57", label: "57 — El M'Ghair" },
  { value: "58", label: "58 — El Meniaa" },
];
